<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.customer.actions.restoreCustomer.title')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Customer } from '~/_api/models/customer'

interface Props {
  customer: Customer
  portal?: string
}

interface Emits {
  (e: 'success'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification, $bus } = useNuxtApp()

const dialog = ref<any>()
const loading = ref(false)

const info = computed(() => {
  return $i18n.t('components.customer.actions.restoreCustomer.info', { name: props.customer.displayName, id: props.customer.idCustomer })
})

const open = () => {
  dialog.value.open()
}

const confirm = async () => {
  loading.value = true

  try {
    const response = await $api.customer.restore(props.customer)

    if (response.success) {
      $notification.toast({
        title: $i18n.t('components.customer.actions.restoreCustomer.success'),
        text: $i18n.t('components.customer.actions.restoreCustomer.successInfo', { name: props.customer.displayName }),
      })

      emit('success')
      $bus.emit.updated('Customer', props.customer)
      return true
    }
  } catch (e: any) {
    $notification.error({ errors: e?.errors })
  }

  loading.value = false
}

defineExpose({ open })
</script>
